export const CardComponentStyles = (props: any) => `
  background-color: ${props.theme.secondary.c000};
  border-radius: 10px;
  padding: 16px;
  display: flex;
  flex-direction: column;
`;
